<template>
  <div>
    <card v-if="isCheckCustomer">
      <b-row>
        <b-col cols="10">
          <b-form class="row" v-on:submit.prevent="doFilter">
            <b-col md="3">
              <el-input class="input-primary" placeholder="Filter dengan kode" clearable v-model="tableFilter.kode"/>
            </b-col>
            <b-col md="3">
              <el-select size="large" clearable v-model="tableFilter.status" placeholder="Filter dengan status">
                <el-option :value="null" label="Semua Status">
                </el-option>
                <el-option :value="0" label="Pending">
                </el-option>
                <el-option :value="1" label="Lunas">
                </el-option>
                <el-option :value="2" label="Tahan">
                </el-option>
              </el-select>
            </b-col>
            <b-col md="4">
              <el-date-picker
                v-model="tableFilter.date"
                type="daterange"
                placeholder="Pick a range">
              </el-date-picker>
            </b-col>
            <b-col md="1">
              <button type="submit" class="btn btn-primary"><font-awesome-icon icon="search"/> Search</button>
            </b-col>
          </b-form>
        </b-col>
        <b-col cols="2">
          <b-button class="float-right" @click="goBack()">Kembali</b-button>
        </b-col>
      </b-row>
      <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :param-no-uuid="true" :no-actions="false"  :active-url="apiUrl" :data-url="apiUrl" :data-key="dataKey" :data-columns="columns" :data-params="['is_active','kode', 'status',  'start_date', 'end_date']">
        <template slot="content_created_by" slot-scope="defaultSlotScope">
          <a :href="'#/users/' + defaultSlotScope.rowData.created_by.id">{{defaultSlotScope.rowData.created_by.name}}</a>
        </template>
        <template slot="content_status" slot-scope="defaultSlotScope">
          <b-badge :variant="getStatusColor(defaultSlotScope.rowData.status)">{{getStatus(defaultSlotScope.rowData.status)}}</b-badge>
        </template>
        <template slot="content_customer" slot-scope="defaultSlotScope">
          <a :href="'#/pengaturan/customer/' + defaultSlotScope.rowData.customer.id">{{defaultSlotScope.rowData.customer.name}}</a>
        </template>
        <template slot="content_last_updated_by" slot-scope="defaultSlotScope">
          <a :href="'#/users/' + defaultSlotScope.rowData.last_updated_by.id">{{defaultSlotScope.rowData.last_updated_by.name}}</a>
        </template>
        <template slot="content_total" slot-scope="defaultSlotScope">
          {{formatNumber(defaultSlotScope.rowData.total)}}
        </template>
        <!-- <template slot="content_actions" slot-scope="defaultSlotScope">
          <div class="text-center">
            <b-button variant="info" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id" class="mb-0 text-center detail mr-1"><i class="fas fa-info"></i></b-button>
            <b-button v-if="defaultSlotScope.rowData.status === 2" variant="primary" size="sm" :href="'#/penjualan/' + defaultSlotScope.rowData.id + '/edit'" class="mb-0 text-center edit"><i class="fas fa-pencil-alt"></i></b-button>
          </div>
        </template> -->
      </paginated-table>
    </card>
    <template v-else>
      <b-row>
        <b-col md="3" v-for="customer in listCustomer" :key="customer.id">
          <a href="#" @click="doCheckOrder(customer.id)" style="color: #333;">
            <card class="p-2">
              <h3 class="p-0 m-0"><strong>{{customer.name}}</strong></h3>
            </card>
          </a>
        </b-col>
      </b-row>
    </template>
  </div>
</template>
<script>
  import { Input, Checkbox, DatePicker, Select, Option } from 'element-ui'
  import PaginatedTable from '@/components/Tables/PaginatedTable'
  import CreateNewData from '@/components/Buttons/CreateNewData'
  import {Progress as LProgress} from 'src/components/index'
  import Card from '../../../../../../web-frontend/src/components/Cards/Card.vue'

  export default {
    components: {
      [Input.name]: Input,
      PaginatedTable,
      CreateNewData,
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
      elCheckbox: Checkbox,
      LProgress,
      Card
    },
    data () {
      return {
        isCheckCustomer: false,
        dataKey: 'order',
        apiUrl: window.AppConfig.apiUrl + 'order',
        apiUrlCustomer: window.AppConfig.apiUrl + 'customer',
        listCustomer: [],
        columns: [
          {
            prop: 'code',
            label: 'Kode',
            sortable: true
          },
          {
            prop: 'customer',
            label: 'Pelanggan',
            sortable: true
          },
          {
            prop: 'total',
            label: 'Total',
            class: 'text-right'
          },
          {
            prop: 'status',
            label: 'Status'
          },
          {
            prop: 'created_by',
            label: 'Dibuat Oleh'
          },
          {
            prop: 'last_updated_by',
            label: 'Diperbarui Oleh'
          },
          {
            prop: 'created_at',
            label: 'Tgl Terbit'
          }
        ],
        fakeTableFilter: {
          is_active: !!this.$route.query.is_active
        },
        tableFilter: {
          is_active: this.$route.query.is_active,
          kode: this.$route.query.kode,
          status: this.$route.query.status,
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          date: null
        }
      }
    },
    watch: {
      'fakeTableFilter.is_active' (value) {
        this.tableFilter.is_active = value ? 1 : null
        this.doFilter()
      }
    },
    mounted () {
      this.getCustomer()
    },
    methods: {
      doFilter () {
        this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
        this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
        this.$refs.dataTable.doFilter(this.tableFilter)
      },
      doCheckOrder (customerId) {
        this.isCheckCustomer = true
        this.apiUrl += '/' + customerId + '/check-invoice?exclude=1customer_id'
      },
      goBack () {
        this.isCheckCustomer = false
        this.apiUrl = window.AppConfig.apiUrl + 'order'
      },
      getCustomer () {
        if (localStorage.getItem('telp')) {
          this.$http.get(this.apiUrlCustomer + '/' + localStorage.getItem('telp') + '/check').then(resp => {
            if (resp.data.length) {
              this.listCustomer = resp.data
            }
          })
          .catch(error => {
            this.isLoading = false
            this.$store.dispatch('notification/error', error)
          })
        } else {
          window.location.href = '/'
        }
      },
      getColorStatus (status) {
        if (status === 'Canceled') {
          return 'dark'
        } else if (status === 'Paid') {
          return 'success'
        } else if (status === 'Invoice') {
          return 'primary'
        } else if (status === 'Working') {
          return 'warning'
        } else if (status === 'New') {
          return 'info'
        } else {
          return 'danger'
        }
      },
      getStatus (value) {
        switch (value) {
          case 0:
            return 'Pending'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'Lunas'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'Tahan'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'Batal'
            // eslint-disable-next-line no-unreachable
            break
          case 4:
            return 'Draft'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getStatusColor (value) {
        switch (value) {
          case 0:
            return 'warning'
            // eslint-disable-next-line no-unreachable
            break
          case 1:
            return 'success'
            // eslint-disable-next-line no-unreachable
            break
          case 2:
            return 'secondary'
            // eslint-disable-next-line no-unreachable
            break
          case 3:
            return 'danger'
            // eslint-disable-next-line no-unreachable
            break
          case 4:
            return 'info'
            // eslint-disable-next-line no-unreachable
            break
        }
      },
      getDate (value) {
        return this.$moment(value).format('DD-MM-YYYY')
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Orders/Index.vue